import { ReactNode } from 'react';
import { Stack } from '@rossum/ui/material';
import { ContentTitle } from './ContentTitle';

type SplitContentProps = {
  title?: ReactNode;
  description: ReactNode;
  children: ReactNode;
  disabled?: boolean;
};

export const SplitContent = ({
  title,
  description,
  children,
  disabled,
}: SplitContentProps) => (
  <Stack direction="row" spacing={4}>
    <Stack
      width="50%"
      direction="row"
      alignItems="flex-start"
      justifyContent="space-between"
      spacing={2}
    >
      <ContentTitle
        title={title}
        description={description}
        disabled={disabled}
      />
    </Stack>
    <Stack width="50%" spacing={3}>
      {children}
    </Stack>
  </Stack>
);
